var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 1.834a6.167 6.167 0 1 0 0 12.333A6.167 6.167 0 0 0 8 1.834ZM.835 8.001a7.167 7.167 0 1 1 14.333 0A7.167 7.167 0 0 1 .834 8Zm7.167-2.167a.833.833 0 0 0-.834.833v.334a.5.5 0 0 1-1 0v-.334a1.833 1.833 0 1 1 3.667 0v.081c0 .508-.202.995-.56 1.354l-.92.919a.5.5 0 1 1-.707-.707l.92-.92a.914.914 0 0 0 .267-.646v-.08a.833.833 0 0 0-.833-.834Zm-.834 4.833a.833.833 0 1 1 1.667 0 .833.833 0 0 1-1.667 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.9c647754db49394e16f02cf79a6aea5e.svg";
export { ForwardRef as ReactComponent };